// extracted by mini-css-extract-plugin
module.exports = {"Stops":"Stops_Stops__bSY_7"};